import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_ENCOUNTERS_KEY } from '_api/queries/encounter';
import { Encounter, EncounterPayload } from '_api/types';

export const CREATE_ENCOUNTER_KEY = 'create-encounter';

export const useCreateEncounter = () => {
  const queryClient = useQueryClient();
  return useApiMutation<Encounter, EncounterPayload>(
    () => '/encounter/create-encounter',
    'post',
    {},
    {
      mutationKey: [CREATE_ENCOUNTER_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ALL_ENCOUNTERS_KEY] });
      },
    },
    (body: EncounterPayload) => JSON.stringify(body),
  );
};
